(function () {
  'use strict';
  if (window.nhApprovedPdpLoaded) return;
  window.nhApprovedPdpLoaded = true;
  var videoCleanups = new Map();

  var profiles = {
    firm: {
      value: '7–9',
      description: 'Firm: 7 to 9 on the Natural Harmony 10-point feel scale.',
      feel: ['Firm and supportive, with some give.', 'More yielding than Extra Firm.'],
      fit: ['People who prefer a firm, less rigid surface.', 'Anyone choosing the softer of these two options.']
    },
    'extra-firm': {
      value: '8–10',
      description: 'Extra Firm: 8 to 10 on the Natural Harmony 10-point feel scale.',
      feel: ['Very firm and highly resistant.', 'The least give in Natural Harmony.'],
      fit: ['People who already know they prefer an extra-firm surface.', 'Anyone choosing the firmest Natural Harmony option.']
    }
  };

  function normaliseProfile(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '-');
  }

  function fillList(list, values) {
    if (!list) return;
    while (list.firstChild) list.removeChild(list.firstChild);
    values.forEach(function (value) {
      var item = document.createElement('li');
      item.textContent = value;
      list.appendChild(item);
    });
  }

  function rangeDescription(profile, value) {
    var label = profile === 'extra-firm' ? 'Extra Firm' : 'Firm';
    return label + ': ' + value.replace('\u2013', ' to ') + ' on the Natural Harmony 10-point feel scale.';
  }

  function setFirmness(section, profile, moveFocus) {
    if (!profiles[profile]) return;
    section.dataset.profile = profile;
    var buttons = section.querySelectorAll('[data-nh-profile]');
    Array.prototype.forEach.call(buttons, function (button) {
      var selected = button.dataset.nhProfile === profile;
      button.setAttribute('aria-checked', String(selected));
      button.tabIndex = selected ? 0 : -1;
      if (selected && moveFocus) button.focus();
    });
    var modelRange = profile === 'extra-firm' ? section.dataset.extraFirmRange : section.dataset.firmRange;
    var range = modelRange || profiles[profile].value;
    section.querySelector('[data-nh-gauge-value]').textContent = range;
    section.querySelector('[data-nh-gauge-description]').textContent = modelRange ? rangeDescription(profile, range) : profiles[profile].description;
    var modelFeel = profile === 'extra-firm' ? section.dataset.extraFirmFeel : section.dataset.firmFeel;
    fillList(section.querySelector('[data-nh-feel]'), modelFeel ? [modelFeel] : profiles[profile].feel);
    fillList(section.querySelector('[data-nh-fit]'), profiles[profile].fit);
  }

  function initFirmness(section) {
    if (section.dataset.nhInitialised === 'true') return;
    section.dataset.nhInitialised = 'true';
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-nh-profile]'));
    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        setFirmness(section, button.dataset.nhProfile, false);
      });
      button.addEventListener('keydown', function (event) {
        var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (keys.indexOf(event.key) === -1) return;
        event.preventDefault();
        var next = index;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
        else next = (index + 1) % buttons.length;
        setFirmness(section, buttons[next].dataset.nhProfile, true);
      });
    });
    setFirmness(section, normaliseProfile(section.dataset.profile) || 'firm', false);
    document.addEventListener('nw:variant', function (event) {
      var purchaseProfile = normaliseProfile(event.detail && event.detail.o2);
      if (profiles[purchaseProfile]) setFirmness(section, purchaseProfile, false);
    });
  }

  function initVideo(video) {
    if (video.dataset.nhInitialised === 'true') return;
    video.dataset.nhInitialised = 'true';
    var frame = video.closest('[data-nh-video-frame]');
    var button = frame && frame.querySelector('[data-nh-motion-toggle]');
    var label = button && button.querySelector('[data-nh-motion-label]');
    var icon = button && button.querySelector('[data-nh-motion-icon]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Round 2 (28 Sep 2026): start hidden so no video file is fetched until the observer says it is near the screen.
    var visible = !('IntersectionObserver' in window);
    var observer;
    var userPaused = reducedMotion.matches;
    var userStarted = false;

    function reflect() {
      if (!button) return;
      var paused = video.paused;
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', (paused ? 'Play' : 'Pause') + ' video');
      if (label) label.textContent = paused ? 'Play video' : 'Pause video';
      if (icon) icon.textContent = paused ? '▶' : 'Ⅱ';
    }

    function update() {
      if (userPaused || !visible || document.hidden) {
        video.pause();
        if (reducedMotion.matches) video.currentTime = 0;
        reflect();
        return;
      }
      // Audit B3 (28 Sep 2026): the video file is only fetched once the video nears the screen.
      var pending = video.querySelector('source[data-src]');
      if (pending && navigator.connection && navigator.connection.saveData && !userStarted) { reflect(); return; }
      if (pending) { pending.src = pending.getAttribute('data-src'); pending.removeAttribute('data-src'); video.load(); }
      var promise = video.play();
      if (promise && promise.catch) promise.catch(reflect);
    }

    function toggle() {
      userPaused = !video.paused;
      if (!userPaused) userStarted = true;
      update();
    }
    if (button) button.addEventListener('click', toggle);
    // 28 Sep 2026 (Nish): no visible pause button, as on DreamCloud; tapping or clicking the video pauses or resumes it.
    video.style.cursor = 'pointer';
    video.addEventListener('click', toggle);
    video.addEventListener('play', reflect);
    video.addEventListener('pause', reflect);
    video.addEventListener('error', function () {
      if (button) button.hidden = true;
      video.controls = true;
    });
    document.addEventListener('visibilitychange', update);
    function motionPreferenceChanged() { userPaused = reducedMotion.matches; update(); }
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', motionPreferenceChanged);
    // Round 4 (29 Sep 2026): the poster (still frame) also waits until the video is within 800px of the screen;
    // the four posters cost about 360 KB on first view. The frame keeps its plain background and 4:3 size until then.
    var posterObserver;
    function showPoster() {
      var p = video.getAttribute('data-poster');
      if (p) { video.setAttribute('poster', p); video.removeAttribute('data-poster'); }
      if (posterObserver) { posterObserver.disconnect(); posterObserver = null; }
    }
    if ('IntersectionObserver' in window) {
      posterObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) showPoster();
      }, { threshold: 0, rootMargin: '800px 0px' });
      posterObserver.observe(video);
      observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        update();
      }, { threshold: 0, rootMargin: '300px 0px' });
      observer.observe(video);
    } else {
      showPoster();
    }
    videoCleanups.set(video, function () {
      if (observer) observer.disconnect();
      if (posterObserver) posterObserver.disconnect();
      document.removeEventListener('visibilitychange', update);
      if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', motionPreferenceChanged);
      video.pause();
    });
    reflect();
    update();
  }

  // Page-wide rule: alternate the rendered sections, not named materials.
  // The firmness film starts on the left; omitted stories consume no position.
  function alternateMediaSections() {
    var mediaLeft = true;
    Array.prototype.forEach.call(document.querySelectorAll('.nh-firmness, .nh-story'), function (section) {
      if (section.hidden || !section.getClientRects().length) return;
      if (section.classList.contains('nh-firmness')) {
        mediaLeft = false;
        return;
      }
      section.classList.toggle('nh-story--media-left', mediaLeft);
      mediaLeft = !mediaLeft;
    });
  }

  function initProductSummary(summary) {
    if (summary.dataset.nhInitialised === 'true') return;
    summary.dataset.nhInitialised = 'true';
    var tabs = Array.prototype.slice.call(summary.querySelectorAll('[data-nh-summary-tab]'));
    var panels = Array.prototype.slice.call(summary.querySelectorAll('[data-nh-summary-panel]'));
    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    }
    tabs.forEach(function (tab, index) {
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', function () { select(index, false); });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
      });
    });
    select(0, false);
    summary.classList.add('is-enhanced');
    summary.querySelector('[role="tablist"]').hidden = false;
  }

  function init(root) {
    var scope = root || document;
    alternateMediaSections();
    Array.prototype.forEach.call(scope.querySelectorAll('[data-nh-product-summary]'), initProductSummary);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-nh-firmness]'), initFirmness);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-nh-approved-video]'), initVideo);
  }

  document.addEventListener('nw:variant', function (event) {
    var profile = normaliseProfile(event.detail && event.detail.o2);
    if (!profiles[profile]) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-nh-firmness]'), function (section) {
      setFirmness(section, profile, false);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-nh-support-copy]'), function (section) {
      section.dataset.profile = profile;
      var output = section.querySelector('[data-nh-support-description]');
      if (output) output.textContent = profile === 'extra-firm' ? section.dataset.extraFirmCopy : section.dataset.firmCopy;
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:unload', function (event) {
    videoCleanups.forEach(function (cleanup, video) {
      if (event.target.contains(video)) { cleanup(); videoCleanups.delete(video); }
    });
    requestAnimationFrame(alternateMediaSections);
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:reorder', alternateMediaSections);
})();
